import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/App/Router/routes';

export const CreateAgreementButton = () => {
  const navigate = useNavigate();

  const handleCreateAgreement = () => {
    navigate(ROUTES.AGREEMENTS.CREATE);
  };

  return (
    <Button
      type='primary'
      icon={<FontAwesomeIcon icon={faPlus} />}
      onClick={handleCreateAgreement}>
      Crear convenio
    </Button>
  );
};